import { useEffect, useState } from 'react';

import { checkApiKeyValid } from '../config/mapyApi';

export type ApiStatus = 'loading' | 'ok' | 'error';

const POLL_INTERVAL_MS = 60_000;

/**
 * Polls Mapy.com API key validity and returns the current status.
 * Shared between ApiStatusBadge (bottom-right indicator) and ModesOverview
 * (panorama section disabled overlay) so the UI stays in sync.
 */
export const useApiStatus = (): ApiStatus => {
    const [status, setStatus] = useState<ApiStatus>('loading');

    useEffect(() => {
        let cancelled = false;
        const checkStatus = async () => {
            const isValid = await checkApiKeyValid();
            if (!cancelled) {
                setStatus(isValid ? 'ok' : 'error');
            }
        };

        checkStatus();
        const interval = setInterval(checkStatus, POLL_INTERVAL_MS);

        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, []);

    return status;
};

export const getNextMonthFirstDay = (): string => {
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    return nextMonth.toLocaleDateString('cs-CZ', {
        day: 'numeric',
        month: 'long',
    });
};
